import { useState, useEffect } from "react";

export const useSubjectAllocationFilters = (onFilterChange) => {
  const [teacherFilter, setTeacherFilter] = useState("");
  const [subjectPaperFilter, setSubjectPaperFilter] = useState("");
  const [classFilter, setClassFilter] = useState("");
  const [yearFilter, setYearFilter] = useState("");
  const [termFilter, setTermFilter] = useState("");
  const [activeFilter, setActiveFilter] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      const filters = {};
      if (teacherFilter) filters.teacher_id = teacherFilter;
      if (subjectPaperFilter) filters.class_stream_subject_paper_id = subjectPaperFilter;
      if (classFilter) filters.class_id = classFilter;
      if (yearFilter) filters.academic_year = yearFilter;
      if (termFilter) filters.term_id = termFilter;
      if (activeFilter !== "") filters.is_active = activeFilter;
      onFilterChange(filters);
    }, 300);
    return () => clearTimeout(timer);
  }, [teacherFilter, subjectPaperFilter, classFilter, yearFilter, termFilter, activeFilter, onFilterChange]);

  const clearFilters = () => {
    setTeacherFilter(""); setSubjectPaperFilter(""); setClassFilter(""); setYearFilter(""); setTermFilter(""); setActiveFilter("");
  };

  const hasActiveFilters = () => {
    return teacherFilter || subjectPaperFilter || classFilter || yearFilter || termFilter || activeFilter !== "";
  };

  return { teacherFilter, setTeacherFilter, subjectPaperFilter, setSubjectPaperFilter, classFilter, setClassFilter, yearFilter, setYearFilter, termFilter, setTermFilter, activeFilter, setActiveFilter, clearFilters, hasActiveFilters };
};
